export default function formAPIMedicinesView({
    id,
    doctorid,
    medicineid,
    medicinename,
    medicinetype,
    dosage,
    dosageunit,
    medicationstartdate,
    medicationenddate,
    frequency,
    frequencytime,
    frequencyvalue,
    morning,
    afternoon,
    evening,
    beforefood,
    afterfood,
    prescribedby,
    prescribedhospitalname,
    iscurrentmedicine,
    medicationstatus_cd,
    medicineunit,
    night,
    chemicalcomposition,
    benefit,
    sideeffects,
    modifieddate,
    remainingquantity,
    fav,

    // new states of medicine input start ||----
    routeofadministration,
    timingofinjection,
    quantitytobeapplied,
    quantity,
    areaofapplication,
    wheretoapply,
    whereToApply,
    diluent,
    infusionduration,
    additives,
    duration,
    rateofinfusionvalue,
    rateofinfusionunit,

    sos,
    custommessage,
    drugclass,
    therapeutic,
    manufacturer,
    instructions,
     // new states of medicine input End ----||

     applicationtiming,
     applicationTiming,
     
  }) {
   
  // normalize alternate property names and provide defaults
  const normalizedQuantity = (quantitytobeapplied !== undefined && quantitytobeapplied !== null)
    ? quantitytobeapplied
    : (quantity !== undefined ? quantity : null);
  const normalizedWhere = (wheretoapply !== undefined && wheretoapply !== null)
    ? wheretoapply
    : (whereToApply !== undefined ? whereToApply : areaofapplication || null);
  const normalizedTiming = (applicationtiming !== undefined && applicationtiming !== null)
    ? applicationtiming
    // : (applicationTiming !== undefined ? applicationTiming : null)
    : (applicationTiming !== undefined && applicationTiming !== null)
      ? applicationTiming
      : (beforefood ? "beforefood" : (afterfood ? "afterfood" : null));

    return Object.freeze({
        id,
    doctorid,
    medicineid,
    medicinename,
    medicinetype,
    dosage,
    dosageunit,
    medicationstartdate,
    medicationenddate,
    frequency,
    frequencytime,
    frequencyvalue,
    morning,
    afternoon,
    evening,
    beforefood,
    afterfood,
    prescribedby,
    prescribedhospitalname,
    iscurrentmedicine,
    medicationstatus_cd,
    medicineunit,
    night,
    chemicalcomposition,
    benefit,
    sideeffects,
    modifieddate,
    remainingquantity,
    fav,

     // new states of medicine input start ||----
    routeofadministration,
    timingofinjection,
    quantitytobeapplied: normalizedQuantity,
    areaofapplication: normalizedWhere,
    diluent,
    infusionduration,
    additives,
    duration,
    rateofinfusionvalue,
    rateofinfusionunit,

    sos,
    custommessage,
    drugclass,
    therapeutic,
    manufacturer,
    instructions,
     // new states of medicine input End ----||

     applicationtiming: normalizedTiming,
     wheretoapply: normalizedWhere,
    
    });
  }
  